var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStepArrow = function SvgStepArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 12,
    fill: "none",
    viewBox: "0 0 20 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A8B2E3",
    d: "M10.756 11.127a1 1 0 0 1-1.512 0L1.041 1.655A1 1 0 0 1 1.797 0h16.406a1 1 0 0 1 .756 1.655z"
  })));
};
export default SvgStepArrow;